<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="sound-tracks">
<h1>Sound Tracks</h1>
<p><em>Sole to Soul</em> occasionally mentions the name of a song. The song titles will be in bold print throughout the chapters. It is suggested for the reader to take a moment and listen to these songs on YouTube to help enhance the experience of the moment.</p><br/>
<p style="text-align: center;text-transform:uppercase;">Page 71 – Love Shack – The B-52s</p>
<p style="text-align: center;text-transform:uppercase;">Page 71 – Time – Culture Club</p>
<p style="text-align: center;text-transform:uppercase;">Page 72 – Welcome to the Jungle – Guns N Roses</p>
<p style="text-align: center;text-transform:uppercase;">Page 72 – Beatin’ the Odds – Molly Hatchet</p>
<p style="text-align: center;text-transform:uppercase;">Page 73 – Funky Town – Lips INC</p>
<p style="text-align: center;text-transform:uppercase;">Page 77 – Dream – Imagine Dragons</p>
<p style="text-align: center;text-transform:uppercase;">Page 132 – Marching on – One Republic</p>
<p style="text-align: center;text-transform:uppercase;">Page 133 – Adrenaline – Gavin Rossdale</p>
<p style="text-align: center;text-transform:uppercase;">page 162 – Red Barchetta – Rush</p>
<p style="text-align: center;text-transform:uppercase;">page 190 – Born To Be Alive – Patrick Hernandez</p>
<p style="text-align: center;text-transform:uppercase;">page 191 – Holiday – Nazareth</p>
<p style="text-align: center;text-transform:uppercase;">page 206 – It’s Raining Men – Weather Girls</p>
<p style="text-align: center;text-transform:uppercase;">page 206 – Home – Edward Sharp and the Magnetic Zeros</p>
<p style="text-align: center;text-transform:uppercase;">page 221 – Machine Head – Bush</p>
<p style="text-align: center;text-transform:uppercase;">page 268 – You’ve Got a Friend – Carole King</p>
<p style="text-align: center;text-transform:uppercase;">page 328 – Walking in My Shoes (Extended Naweed Mix) – Depeche Mode</p>
<p style="text-align: center;text-transform:uppercase;"><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?02d39314